export default __webpack_public_path__ + "static/mobile_dock-a951562526fc085de010a77ba25231bf.png";